// Enter押下で次のinputにフォーカスを当てる共通関数

export const focusNextInput = (
  e: React.KeyboardEvent<HTMLInputElement | HTMLButtonElement>,
  inputs: React.RefObject<(HTMLInputElement | HTMLButtonElement)[]>,
  index: number
) => {
  if (e.key === 'Enter') {
    e.preventDefault();

    // 次の input を取得。最後のinputの場合は最初のinputに戻る
    const nextIndex = (index + 1) % inputs.current.length;
    const nextInput = inputs.current[nextIndex];
    if (nextInput) {
      nextInput.focus();
    }
  }
};
